export var MessageTypes;
(function (MessageTypes) {
    MessageTypes["START_APPLICATION"] = "START_APPLICATION";
    MessageTypes["CREATE_REDIRECT"] = "CREATE_REDIRECT";
    MessageTypes["TARGET_ADDRESS_ENTERED"] = "TARGET_ADDRESS_ENTERED";
    MessageTypes["CLOSE_WIDGET"] = "CLOSE_WIDGET";
})(MessageTypes || (MessageTypes = {}));
export const UserMessageTypes = [MessageTypes.TARGET_ADDRESS_ENTERED];
